import { render, staticRenderFns } from "./ClassroomDetailCreateMessage.vue?vue&type=template&id=0e0e64b2&scoped=true"
import script from "./ClassroomDetailCreateMessage.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailCreateMessage.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailCreateMessage.vue?vue&type=style&index=0&id=0e0e64b2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0e64b2",
  null
  
)

export default component.exports